import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export const Splash = ({ t }) => {
  const [phase, setPhase] = useState("in");
  const close = () => { setPhase("out"); setTimeout(() => setPhase("gone"), 500); };
  useEffect(() => { if (phase === "gone") window.dispatchEvent(new Event("drnova:splash-done")); }, [phase]);
  if (phase === "gone") return null;
  return createPortal(
    <div data-testid="splash-screen" aria-live="polite"
      className={`fixed inset-0 z-[100] grid place-items-center overflow-hidden transition-opacity duration-500 ${phase === "out" ? "opacity-0" : "opacity-100"}`}>
      <div className="splash-bg" aria-hidden />
      <div className="absolute inset-0 flex flex-col items-center justify-end px-8 pb-[11dvh] text-center">
        <p className="font-display splash-text mb-4 max-w-xs text-2xl sm:max-w-lg font-bold leading-snug text-slate-900 sm:text-3xl" data-testid="splash-message">{t("splash")}</p>
        <div className="relative flex flex-col items-center">
          <img src="/doctor-hq.webp" alt="Dr. Nova" data-testid="splash-avatar" decoding="async"
            className="splash-pop relative h-[52dvh] max-h-[480px] w-auto" style={{ aspectRatio: "1176 / 2344" }} />
          <span className="absolute -bottom-2 h-5 w-40 rounded-[50%] bg-slate-900/25 blur-md" aria-hidden />
        </div>
      </div>
      <div className="splash-text absolute inset-x-0 bottom-[3dvh] z-10 flex justify-center">
        <button data-testid="splash-start-btn" onClick={close} className="btn-primary min-w-[180px] !py-3 text-base shadow-lg">{t("start")}</button>
      </div>
    </div>,
    document.body
  );
};
